import { render, staticRenderFns } from "./ReasonList.vue?vue&type=template&id=e13167c6&scoped=true&"
import script from "./ReasonList.vue?vue&type=script&lang=js&"
export * from "./ReasonList.vue?vue&type=script&lang=js&"
import style0 from "./ReasonList.vue?vue&type=style&index=0&id=e13167c6&lang=scss&scoped=true&"
import style1 from "./ReasonList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13167c6",
  null
  
)

export default component.exports